(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rt-about-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rt-about-chapter')) {
 class ReTechAboutChapter extends HTMLElement {
  connectedCallback() {
   this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
   this.reveal = new Set(this.querySelectorAll('[data-enter]'));
   this.videos = [...this.querySelectorAll('video')];
   this.onMotion = () => {
    if (this.motion.matches) {
     this.querySelectorAll('[data-enter]').forEach(el => el.getAnimations().forEach(animation => animation.cancel()));
     this.videos.forEach(video => video.pause());
    }
   };
   this.motion.addEventListener('change', this.onMotion);
   if (!('IntersectionObserver' in window)) return;
   this.observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
     const el = entry.target;
     if (el.tagName === 'VIDEO') {
      if (!entry.isIntersecting || this.motion.matches) el.pause();
      else if (!el.dataset.rtaManual) el.play().catch(() => {});
      return;
     }
     if (!entry.isIntersecting) return;
     if (!this.motion.matches && el.animate) {
      el.animate([{opacity:0.35,transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}],{duration:480,easing:'cubic-bezier(.2,.65,.3,1)'});
     }
     this.observer.unobserve(el);
    });
   }, {threshold:0.06});
   this.reveal.forEach(el => this.observer.observe(el));
   this.onVideoControl = event => { if(event.target.tagName === 'VIDEO') event.target.dataset.rtaManual = 'true'; };
   this.addEventListener('pointerdown', this.onVideoControl);
   this.addEventListener('keydown', this.onVideoControl);
   this.videos.forEach(video => this.observer.observe(video));
   this.onVisibility = () => {if(document.hidden) this.videos.forEach(video => video.pause());};
   document.addEventListener('visibilitychange', this.onVisibility);
  }
  disconnectedCallback() {
   this.observer?.disconnect();
   this.motion?.removeEventListener('change', this.onMotion);
   this.removeEventListener('pointerdown', this.onVideoControl);
   this.removeEventListener('keydown', this.onVideoControl);
   document.removeEventListener('visibilitychange', this.onVisibility);
  }
 }
 customElements.define('rt-about-chapter', ReTechAboutChapter);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rt-cart"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-rt-cart-page]');
  if (!root) return;
  var form = root.querySelector('[data-cart-page-form]');
  if (!form) return;
  var error = root.querySelector('[data-cart-update-error]');
  function money(cents, currency) { return new Intl.NumberFormat(document.documentElement.lang || 'bg', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100); }
  root.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-cart-page-action]');
    if (!button) return;
    event.preventDefault();
    if (window.rtCartChangePending || typeof window.rtCartChange !== 'function') return;
    var row = button.closest('[data-cart-key]');
    var current = Number(row.dataset.cartQuantity);
    var action = button.dataset.cartPageAction;
    var next = action === 'remove' ? 0 : action === 'increase' ? current + 1 : Math.max(0, current - 1);
    error.hidden = true;
    var result = await window.rtCartChange(row.dataset.cartKey, next);
    if (result && result.error) {
      error.textContent = result.error === 'stock' ? root.dataset.stockError : root.dataset.updateError;
      error.hidden = false;
      error.focus({ preventScroll: true });
    }
  });
  document.addEventListener('rt:cart-busy', function (event) {
    form.setAttribute('aria-busy', String(event.detail));
    form.querySelectorAll('button').forEach(function (button) {
      if (event.detail) { button.dataset.wasDisabled = String(button.disabled); button.disabled = true; }
      else if (button.dataset.wasDisabled !== undefined) { button.disabled = button.dataset.wasDisabled === 'true'; delete button.dataset.wasDisabled; }
    });
  });
  document.addEventListener('rt:cart-updated', function (event) {
    var cart = event.detail;
    error.hidden = true;
    root.querySelectorAll('[data-cart-key]').forEach(function (row) {
      var item = cart.items.find(function (item) { return item.key === row.dataset.cartKey; });
      if (!item) { row.remove(); return; }
      row.dataset.cartQuantity = item.quantity;
      row.querySelector('.rt-cart-qty .v').textContent = item.quantity;
      row.querySelector('.rt-cart-line-price').textContent = money(item.final_line_price, cart.currency);
    });
    root.querySelector('[data-cart-page-total]').textContent = money(cart.total_price, cart.currency);
    form.hidden = cart.item_count === 0;
    root.querySelector('[data-cart-became-empty]').hidden = cart.item_count !== 0;
    var count = root.querySelector('[data-cart-item-count]');
    if (count) { count.hidden = cart.item_count === 0; count.textContent = cart.item_count === 1 ? root.dataset.countOne : root.dataset.countMany.replace('999999', cart.item_count); }
    var delivery = root.querySelector('[data-rt-delivery]');
    if (delivery) {
      delivery.hidden = cart.item_count === 0;
      var rates = delivery.querySelector('[data-delivery-result]');
      if (rates && rates.textContent) rates.textContent = delivery.dataset.stale;
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
